import getActionCable, { createWebsocketListener } from '../../../utils/actioncable';
import createMetadataAPIActions from '../../utils/api-metadata-actions';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';

const options = {
  name: 'p2000Messages',
  baseType: 'P2000_MESSAGES',
  apiEndpoint: 'p2000_messages'
};

const actions = createMetadataAPIActions(options);
const defaultOperations = createMetadataAPIOperations(options);

let dispatch = null;
const registerForRealTimeUpdates =
  ({ addresses }, actionCable) =>
  d => {
    dispatch = d;

    if (!addresses || addresses.length === 0) {
      return null;
    }

    const subscribeToWebsocket = () => {
      actionCable = actionCable || getActionCable();
      const connectHandler = () => console.log(`Connected to P2000MessageChannel for ${addresses}`);

      const retryHandler = () => registerForRealTimeUpdates({ addresses }, actionCable);

      const listener = createWebsocketListener({
        dispatch,
        connectHandler,
        receivedHandler: message => {
          dispatch(actions.fetchSuccessful([message], { replace: false }));
        },
        retryHandler
      });

      const channelData = {
        channel: 'P2000MessageChannel',
        addresses: String(addresses.join(','))
      };

      return actionCable.subscriptions.create(channelData, listener);
    };

    // Subscribe to websocket for incremental updates
    return subscribeToWebsocket();
  };

export default {
  ...defaultOperations,
  registerForRealTimeUpdates
};
